import { mapActions, mapGetters, mapMutations } from 'vuex'
import general from '../general/index.vue'
import widgetsHistory from '../history/index.vue'

export default {
  name: 'setting-widgets-dialog-view',
  data () {
    return {
      dialog: true,
      activeTab: 'general',
    }
  },
  components: {
    general,
    widgetsHistory
  },
  watch: {
    openDialogView () {
      this.dialog = this.openDialogView
    }
  },
  computed: {
    ...mapGetters({
      currentItem: 'settingWidgets/currentItem',
      openDialogView: 'settingWidgets/openDialogView',
      basicLocales: 'setting/basicLocales',
      editId: 'settingWidgets/editId',
	  isLoading: 'settingWidgets/isLoading'
    }),
    tabs () {
      const tabs = [
        {
          name: 'General',
          slug: 'general',
          id: 1
        }
      ]

      // History is only meaningful for an existing widget — snapshots are
      // created on edit, so hide the tab entirely while creating a new one.
      if (this.editId) {
        tabs.push({
          name: 'History',
          slug: 'history',
          id: 2
        })
      }

      return tabs
    }
  },
  created () {
    if (!this.basicLocales.length) {
      this.fetchBasicLocales()
    }
    if (this.editId) {
      this.fetchItem()
    }
  },
  methods: {
    ...mapActions({
      fetchItem: 'settingWidgets/GET_LIST_ITEM',
      fetchBasicLocales: 'setting/GET_BASIC_LOCALES'
    }),
    ...mapMutations({
      changeDialogView: 'settingWidgets/CHANGE_DIALOG_VIEW',
      changeEditId: 'settingWidgets/CHANGE_EDIT_ID',
      setContent: 'settingWidgets/SET_ITEM'
    }),
    changeCloseDialog () {
      this.dialog = false
      this.changeDialogView(false)
      this.changeEditId('')
    },

	save(){
	  this.$refs['general'].$emit('event-save');
	},
    // After a successful restore re-fetch the widget so the GENERAL form
    // rehydrates from the rolled-back snapshot, then surface it to the operator.
    onVersionRestored () {
      // VERSION_RESTORE already commits SET_ITEM with the server response,
      // which re-hydrates the general form via its currentItem watcher —
      // no extra fetch needed.
      this.activeTab = 'general'
    }
  },
  destroyed () {
    this.setContent(null)
  }
}
